// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPauseIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M9 18a1.5 1.5 0 0 1-3 0V6a1.5 1.5 0 1 1 3 0zm9.1 0a1.5 1.5 0 0 1-3 0V6a1.5 1.5 0 1 1 3 0z" />
  </g>
);
export default SvgPauseIcon;
SvgPauseIcon.displayName = 'SvgPauseIcon';
